
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("crFp4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "JiraConnectGeneralPage", () => $9e36e97c0a79b8a4$export$3aacc42bb7864b7c);
$parcel$export(module.exports, "default", () => $9e36e97c0a79b8a4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("39ZjR");

var $jzjy1 = parcelRequire("jzjy1");

var $6MtPV = parcelRequire("6MtPV");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $i6fQW = parcelRequire("i6fQW");

var $hz6Yb = parcelRequire("hz6Yb");

var $2FOOv = parcelRequire("2FOOv");

var $2YP9W = parcelRequire("2YP9W");
var $1bQGJ = parcelRequire("1bQGJ");
const $9e36e97c0a79b8a4$export$3aacc42bb7864b7c = ({ query: query, match: match })=>{
    const baseUrl = '';
    const addonKey = match.params.addonKey || '';
    const moduleKey = match.params.moduleKey || '';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $i6fQW.useAnalyticsEvents)();
    const state = (0, $2YP9W.useResource)((0, $hz6Yb.connectGeneralResources));
    const moduleType = state?.data?.moduleType;
    const analyticsAttributes = (0, $5uXOq.useCallback)(()=>(0, $6MtPV.createAttributes)(), []);
    const attributes = (0, $5uXOq.useMemo)(()=>({
            addonKey: addonKey,
            moduleKey: moduleKey,
            moduleType: moduleType,
            ...analyticsAttributes()
        }), [
        addonKey,
        moduleKey,
        moduleType,
        analyticsAttributes
    ]);
    const onLoadingComplete = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireScreenAnalytics)(createAnalyticsEvent({}), attributes);
    }, [
        attributes,
        createAnalyticsEvent
    ]);
    const onTimeout = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'JiraConnectGeneralPage timeout', attributes);
    }, [
        createAnalyticsEvent,
        attributes
    ]);
    const onError = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'JiraConnectGeneralPage failed', attributes);
    }, [
        createAnalyticsEvent,
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        key: `${addonKey}-${moduleKey}-${JSON.stringify(query)}`,
        action: "initialized",
        actionSubject: "JiraConnectGeneralPage",
        actionSubjectId: `connect-iFrame-${addonKey}-${moduleKey}`,
        attributes: attributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2FOOv.default), {
        // @ts-expect-error - TS2322 - Type '{ prefetchResult: UseResourceHookResponse<any>; baseUrl: string; addonKey: string; moduleKey: string; queryParams: Query; }' is not assignable to type 'IntrinsicAttributes & Diff<RefAttributes<any> | (RefAttributes<any> & { children?: ReactNode; }), Partial<RefAttributes<any> | (RefAttributes<...> & { ...; })>> & RefAttributes<...> & { ...; }'.
        prefetchResult: state,
        baseUrl: baseUrl,
        addonKey: addonKey,
        moduleKey: moduleKey,
        queryParams: query,
        onTimeout: onTimeout,
        onError: onError,
        onLoadingComplete: onLoadingComplete
    }));
};
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$9e36e97c0a79b8a4$export$2e2bcd8739ae039 // eslint-disable-line @typescript-eslint/no-explicit-any
 = (0, $1bQGJ.withRouter)((0, $jzjy1.AnalyticsSource)('JiraConnectGeneralPage', (0, $4d5e0871c06cee03$export$f636b5b56f1d624a))(// @ts-expect-error - Argument of type '({ query, match }: Props) => JSX.Element' is not assignable to parameter of type 'ComponentType<Record<any, any>>'.
$9e36e97c0a79b8a4$export$3aacc42bb7864b7c));

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("2FOOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $9531aa7ed0ff8e95$export$2e2bcd8739ae039);

var $9sGI6 = parcelRequire("9sGI6");

var $kjCe0 = parcelRequire("kjCe0");

var $l8CHx = parcelRequire("l8CHx");
var $9531aa7ed0ff8e95$export$2e2bcd8739ae039 = (0, $9sGI6.default)((0, $l8CHx.default), {
    ConnectIframeLegacyApp: $kjCe0.default
});

});
parcelRegister("kjCe0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9583d9f00b9c258$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");
parcelRequire("lGUc9");
var $ePhLx = parcelRequire("ePhLx");

var $kb4zh = parcelRequire("kb4zh");

var $hhZhQ = parcelRequire("hhZhQ");

var $dJl1T = parcelRequire("dJl1T");

var $jjUR3 = parcelRequire("jjUR3");

var $dJZWD = parcelRequire("dJZWD");

var $i2Rm5 = parcelRequire("i2Rm5");

var $jfasb = parcelRequire("jfasb");
class $e9583d9f00b9c258$export$d06c0a963328bad5 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props), this.connectIframeProvider = new (0, $hhZhQ.default)({
            handleOnLoadingComplete: this.props.onLoadingComplete,
            handleOnTimeout: this.props.onTimeout
        });
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const { prefetchResult: prefetchResult, connectHostDi: connectHostDi = !false ? window.connectHost : undefined } = props;
        this.state = {
            options: prefetchResult || undefined,
            connectHost: connectHostDi,
            loading: false,
            error: null
        };
    }
    componentDidMount() {
        if (!this.state.options) this.getData();
        if (!this.state.connectHost && !false) this.loadHost();
    }
    componentDidUpdate(prevProps) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevProps.queryParams, this.props.queryParams) || prevProps.addonKey !== this.props.addonKey || prevProps.moduleKey !== this.props.moduleKey) this.getData();
    }
    getData() {
        this.setState({
            loading: true
        });
        (0, $jfasb.default)(this.props.baseUrl, this.props.addonKey, this.props.moduleKey, this.props.queryParams).then((options)=>{
            this.setState({
                options: options
            });
        }).catch((error)=>{
            this.setState({
                error: error
            });
            (0, $dJl1T.default).safeErrorWithoutCustomerData('connect-iframe', 'Failed to fetch module configuration', error);
        }).finally(()=>{
            this.setState({
                loading: false
            });
        });
    }
    loadHost() {
        (0, $dJZWD.setupConnectJs)().then((connectHost)=>{
            this.setState({
                connectHost: connectHost
            });
        }).catch((error)=>{
            this.setState({
                error: error
            });
            (0, $dJl1T.default).safeErrorWithoutCustomerData('connect-iframe', 'Failed to get connect host', error);
        });
    }
    render() {
        const { addonKey: addonKey, moduleKey: moduleKey, frameHeight: frameHeight, frameWidth: frameWidth, TimeoutIndicator: TimeoutIndicator, LoadingIndicator: LoadingIndicator } = this.props;
        const { options: options, connectHost: connectHost, error: error, loading: loading } = this.state;
        if (error) {
            if (this.props.onError) this.props.onError();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TimeoutIndicator, {
                error: error
            });
        }
        return options && connectHost && !loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePhLx.ConnectIframe), {
            ...options,
            // @ts-expect-error - TS2739 - Type 'Readonly<Readonly<{ status?: number | undefined; addon_key?: string | undefined; uniqueKey?: string | undefined; ns?: string | undefined; moduleType?: string | undefined; moduleLocation?: string | undefined; ... 24 more ...; targets?: { ...; } | undefined; }> & { ...; }>' is missing the following properties from type 'AppOptions': widthinpx, hostFrameOffset, _contextualOperations
            options: options,
            height: frameHeight,
            width: frameWidth,
            connectHost: connectHost,
            // @ts-expect-error - TS2322 - Type 'ComponentType<Record<any, any>>' is not assignable to type 'typeof PureComponent'.
            loadingIndicator: LoadingIndicator,
            // @ts-expect-error - TS2322 - Type 'ComponentType<{ error: Error; }>' is not assignable to type 'new () => PureComponent<{ failedCallback: Function; }, {}, any>'.
            timeoutIndicator: TimeoutIndicator,
            appKey: addonKey,
            connectIframeProvider: this.connectIframeProvider,
            moduleKey: moduleKey,
            key: options.url
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, null);
    }
}
const $e9583d9f00b9c258$export$8968565585c2471b = (props)=>{
    const { history: history } = (0, $jjUR3.useConnectItemClickHistory)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9583d9f00b9c258$export$d06c0a963328bad5, {
        ...props,
        key: history.unique.length
    });
};
$e9583d9f00b9c258$export$8968565585c2471b.defaultProps = {
    prefetchResult: null,
    frameHeight: '100%',
    frameWidth: '100%',
    TimeoutIndicator: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
            id: "jira-connect",
            error: error
        }),
    LoadingIndicator: (0, $kb4zh.default),
    queryParams: {}
};
var $e9583d9f00b9c258$export$2e2bcd8739ae039 = $e9583d9f00b9c258$export$8968565585c2471b;

});
parcelRegister("lGUc9", function(module, exports) {

$parcel$export(module.exports, "ConnectIframe", () => (parcelRequire("ePhLx")).ConnectIframe);

var $cTPBv = parcelRequire("cTPBv");

var $3NSA0 = parcelRequire("3NSA0");

var $aqhgV = parcelRequire("aqhgV");

var $35ARm = parcelRequire("35ARm");

var $ePhLx = parcelRequire("ePhLx");

var $lmpfU = parcelRequire("lmpfU");

var $bVKdY = parcelRequire("bVKdY");

var $dfrrn = parcelRequire("dfrrn");

var $3ZL3k = parcelRequire("3ZL3k");

var $6WeGo = parcelRequire("6WeGo");

var $bw22u = parcelRequire("bw22u");

var $2VbVm = parcelRequire("2VbVm");

var $3J6n1 = parcelRequire("3J6n1");

var $d4ZAG = parcelRequire("d4ZAG");

var $910u1 = parcelRequire("910u1");

var $bIfPx = parcelRequire("bIfPx");

var $ioF2x = parcelRequire("ioF2x");

var $4o6FR = parcelRequire("4o6FR");

var $ch5cI = parcelRequire("ch5cI");

});
parcelRegister("cTPBv", function(module, exports) {

$parcel$export(module.exports, "analytics", () => $9642a689fbc72bfd$export$71a493436f9bccb6);

var $kKwEH = parcelRequire("kKwEH");

var $2VbVm = parcelRequire("2VbVm");
var $9642a689fbc72bfd$var$AnalyticsController = /** @class */ function() {
    function AnalyticsController() {
        this.loggingEnabled = false;
    }
    AnalyticsController.prototype.isLoggingEnabled = function() {
        return this.loggingEnabled;
    };
    /**
     * In the browser console, enable analytics logging by entering window._analyticsController.enableAnalyticsLogging().
     */ AnalyticsController.prototype.enableAnalyticsLogging = function() {
        console.info('Enabling analytics logging...');
        this.loggingEnabled = true;
        return "Analytics logging is now enabled. (>'-')> <('_'<) ^('_')\- \m/(-_-)\m/ <( '-')> \_( .\")> <( ._.)-`";
    };
    /**
     * In the browser console, disable analytics logging by entering window._analyticsController.disableAnalyticsLogging().
     */ AnalyticsController.prototype.disableAnalyticsLogging = function() {
        console.info('Disabling analytics logging...');
        this.loggingEnabled = false;
        return "Analytics logging is now disabled. \xaf\\_(\u30C4)_/\xaf";
    };
    return AnalyticsController;
}();
/**
 * This class serves two purposes:
 *   - It provides the ability for products to register their implementations
 *     of AnalyticsAPI for use by the connect front end code.
 *   - It provides the AnalyticsAPI implementation that connect front end code
 *     should use. This implementation delegates to the registered AnalyticsAPI
 *     implementation. This class should be used within the connect front end
 *     code as follows:
 *
 *     import analytics from '../adaptors/analytics/AnalyticsAdaptor';
 *
 *     analytics.trigger('Flags', 'close', {'type': 'warning'});
 */ var $9642a689fbc72bfd$var$AnalyticsAdaptor = /** @class */ function() {
    function AnalyticsAdaptor() {
        this.analyticsAPI = (0, $kKwEH.default);
        this.analyticsController = new $9642a689fbc72bfd$var$AnalyticsController();
        window._analyticsController = this.analyticsController;
    }
    /**
     * Implementation of AnalyticsRegistry#registerAnalyticsAPI().
     */ AnalyticsAdaptor.prototype.registerAnalyticsAPI = function(analyticsAPI) {
        this.analyticsAPI = analyticsAPI;
    };
    /**
     * Implementation of AnalyticsAPI#trigger() for use by connect-module-core code.
     */ AnalyticsAdaptor.prototype.trigger = function(category, action, appKey, payload) {
        try {
            this.analyticsAPI.trigger(category, action, appKey, payload);
            if (this.analyticsController.isLoggingEnabled()) (0, $2VbVm.logger).info('Analytics:', category, action, appKey, payload);
        } catch (exception) {
            (0, $2VbVm.logger).warn('Exception trapped triggering analytics event', exception);
        }
    };
    AnalyticsAdaptor.prototype.markAsSafe = function() {
        var allowedStrings = [];
        for(var _i = 0; _i < arguments.length; _i++)allowedStrings[_i] = arguments[_i];
        if (this.analyticsAPI.markAsSafe) return (_a = this.analyticsAPI).markAsSafe.apply(_a, allowedStrings);
        else return (0, $kKwEH.default).markAsSafe.apply((0, $kKwEH.default), allowedStrings);
        var _a;
    };
    AnalyticsAdaptor.prototype.dangerouslyCreateSafeString = function(value) {
        if (this.analyticsAPI.dangerouslyCreateSafeString) return this.analyticsAPI.dangerouslyCreateSafeString(value);
        else return (0, $kKwEH.default).dangerouslyCreateSafeString(value);
    };
    return AnalyticsAdaptor;
}();
var $9642a689fbc72bfd$export$71a493436f9bccb6 = new $9642a689fbc72bfd$var$AnalyticsAdaptor();

});
parcelRegister("kKwEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1b16f3c8b3fa063$export$2e2bcd8739ae039);
var $f1b16f3c8b3fa063$var$DefaultAnalyticsAPI = /** @class */ function() {
    function DefaultAnalyticsAPI() {}
    DefaultAnalyticsAPI.prototype.trigger = function(category, action, payload) {
    // Do nothing.
    };
    DefaultAnalyticsAPI.prototype.markAsSafe = function() {
        var allowedStrings = [];
        for(var _i = 0; _i < arguments.length; _i++)allowedStrings[_i] = arguments[_i];
        // Do no filtering
        return function(value) {
            return value;
        };
    };
    DefaultAnalyticsAPI.prototype.dangerouslyCreateSafeString = function(value) {
        // Do nothing
        return value;
    };
    return DefaultAnalyticsAPI;
}();
var $f1b16f3c8b3fa063$export$2e2bcd8739ae039 = new $f1b16f3c8b3fa063$var$DefaultAnalyticsAPI();

});

parcelRegister("2VbVm", function(module, exports) {

$parcel$export(module.exports, "logger", () => $220a278f17f8a1e1$export$af88d00dbe7f521);

var $kttW5 = parcelRequire("kttW5");
var $220a278f17f8a1e1$var$LoggerController = /** @class */ function() {
    function LoggerController() {
        this.debugEnabled = false;
        this.infoEnabled = true;
    }
    LoggerController.prototype.isDebugEnabled = function() {
        return this.debugEnabled;
    };
    LoggerController.prototype.isInfoEnabled = function() {
        return this.infoEnabled;
    };
    /**
     * In the browser console, enable debug by entering window._loggerController.enableDebug().
     */ LoggerController.prototype.enableDebug = function() {
        console.info('Enabling debug...');
        this.debugEnabled = true;
        return "Debug level logging is now enabled.   \u06DC(\u05E1\u05BC\u06BA\u05E1\u05BC\u064E` )/\u06DC";
    };
    /**
     * In the browser console, disable debug by entering window._loggerController.disableDebug().
     */ LoggerController.prototype.disableDebug = function() {
        console.info('Disabling debug...');
        this.debugEnabled = false;
        return "Debug level logging is now disabled. \u03B5(\xb4\u05E1\u05BC\uFE35\u05E1\u05BC`)\u0437";
    };
    /**
     * In the browser console, enable info by entering window._loggerController.enableInfo().
     */ LoggerController.prototype.enableInfo = function() {
        console.info('Enabling info...');
        this.infoEnabled = true;
        return "Info level logging is now enabled. \u3010\u30C4\u3011";
    };
    /**
     * In the browser console, disable info by entering window._loggerController.disableInfo().
     * <br/>
     * <strong>Note</strong>: disabling info will also disable debug.
     */ LoggerController.prototype.disableInfo = function() {
        console.info('Disabling info...');
        this.debugEnabled = false;
        this.infoEnabled = false;
        return 'Info level logging is now disabled. (-.-)Zzz...';
    };
    return LoggerController;
}();
/**
 * This class serves two purposes:
 *   - It provides the ability for products to register their implementations
 *     of LoggerAPI for use by the connect front end code.
 *   - It provides the LoggerAPI implementation that connect front end code
 *     should use. This implementation delegates to the registered LoggerAPI
 *     implementation. This class should be used within the connect front end
 *     code as follows:
 *
 *     import logger from '../adaptors/logger/LoggerAdaptor';
 *
 *     logger.info('My message', extraStuffOfInterest, etc, ...);
 */ var $220a278f17f8a1e1$var$LoggerAdaptor = /** @class */ function() {
    function LoggerAdaptor() {
        this.loggerAPI = (0, $kttW5.default);
        this.loggerController = new $220a278f17f8a1e1$var$LoggerController();
        window._loggerController = this.loggerController;
    }
    /**
     * Implementation of AnalyticsRegistry#registerAnalyticsAPI().
     */ LoggerAdaptor.prototype.registerLoggerAPI = function(loggerAPI) {
        this.loggerAPI = loggerAPI;
    };
    /**
     * Implementation of LoggerAPI#debug() for use by connect-module-core code.
     */ LoggerAdaptor.prototype.debug = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        try {
            if (this.loggerController.isDebugEnabled()) this.loggerAPI.debug.apply(this.loggerAPI, arguments);
        } catch (exception) {
        // Ignore
        }
    };
    /**
     * Implementation of LoggerAPI#info() for use by connect-module-core code.
     */ LoggerAdaptor.prototype.info = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        try {
            if (this.loggerController.isInfoEnabled()) this.loggerAPI.info.apply(this.loggerAPI, arguments);
        } catch (exception) {
        // Ignore
        }
    };
    /**
     * Implementation of LoggerAPI#warn() for use by connect-module-core code.
     */ LoggerAdaptor.prototype.warn = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        try {
            this.loggerAPI.warn.apply(this.loggerAPI, arguments);
        } catch (exception) {
            var logger_1 = console.warn || console.log;
            if (logger_1) logger_1.apply(logger_1, arguments);
        }
    };
    /**
     * Implementation of LoggerAPI#error() for use by connect-module-core code.
     */ LoggerAdaptor.prototype.error = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        try {
            this.loggerAPI.error.apply(this.loggerAPI, arguments);
        } catch (exception) {
            var logger_2 = console.error || console.log;
            if (logger_2) logger_2.apply(logger_2, arguments);
        }
    };
    return LoggerAdaptor;
}();
var $220a278f17f8a1e1$export$af88d00dbe7f521 = new $220a278f17f8a1e1$var$LoggerAdaptor();

});
parcelRegister("kttW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee7dbcbbfc3e5667$export$2e2bcd8739ae039);
var $ee7dbcbbfc3e5667$var$DefaultLoggerAPI = /** @class */ function() {
    function DefaultLoggerAPI() {}
    DefaultLoggerAPI.prototype.debug = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        console.debug.apply(console, arguments);
    };
    DefaultLoggerAPI.prototype.info = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        console.info.apply(console, arguments);
    };
    DefaultLoggerAPI.prototype.warn = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        console.warn.apply(console, arguments);
    };
    DefaultLoggerAPI.prototype.error = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        console.error.apply(console, arguments);
    };
    return DefaultLoggerAPI;
}();
var $ee7dbcbbfc3e5667$export$2e2bcd8739ae039 = new $ee7dbcbbfc3e5667$var$DefaultLoggerAPI();

});



parcelRegister("3NSA0", function(module, exports) {

var $3VFsf = parcelRequire("3VFsf");

var $aqhgV = parcelRequire("aqhgV");
/**
 * This class provides the Adaptor implementation for ACJS
 */ var $2c504918b1514aad$var$ACJSFrameworkAdaptor = /** @class */ function(_super) {
    $3VFsf.__extends(ACJSFrameworkAdaptor, _super);
    function ACJSFrameworkAdaptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ACJSFrameworkAdaptor.prototype.registerModuleWithHost = function(moduleName, simpleXdmDefinition) {
    // Do nothing - ACJS is already registering all core modules.
    };
    ACJSFrameworkAdaptor.prototype.getProviderByModuleName = function(moduleName) {
        return _super.prototype.getProviderByModuleName.call(this, moduleName);
    };
    return ACJSFrameworkAdaptor;
}((0, $aqhgV.BaseFrameworkAdaptor));
var $2c504918b1514aad$export$8782e9f160c2e1e7 = new $2c504918b1514aad$var$ACJSFrameworkAdaptor();

});
parcelRegister("aqhgV", function(module, exports) {

$parcel$export(module.exports, "BaseFrameworkAdaptor", () => $7969baf87482f2f3$export$4944e39ef1fb1533);
/**
 * This class provides common behaviour relating to the adaption of functionality to a
 * particular Connect client framework. This is necessary for an interim period during which
 * we have multiple Connect client frameworks that we need to support: ACJS and CaaS Client.
 */ var $7969baf87482f2f3$export$4944e39ef1fb1533 = /** @class */ function() {
    function BaseFrameworkAdaptor() {
        this.moduleNamesToModules = new Map();
    }
    /**
     * This method registers a module with the Connect client framework relating to this adaptor instance.
     * @param moduleDefinition the definition of the module.
     */ BaseFrameworkAdaptor.prototype.registerModule = function(module, props) {
        var moduleRegistrationName = module.getModuleRegistrationName();
        this.moduleNamesToModules.set(moduleRegistrationName, module);
        var simpleXdmDefinitionBuilder = module.getSimpleXdmDefinitionBuilder();
        var simpleXdmDefinition = simpleXdmDefinitionBuilder.buildSimpleXdmDefinition();
        this.registerModuleWithHost(moduleRegistrationName, simpleXdmDefinition);
    };
    BaseFrameworkAdaptor.prototype.getModuleByName = function(moduleName) {
        return this.moduleNamesToModules.get(moduleName);
    };
    /**
     * This routine gets a module provider based on the module's name. The provider will only be returned if
     * the module is enabled.
     * @param moduleName the name of the module.
     * @returns {any} the module provider if found and enabled.
     */ BaseFrameworkAdaptor.prototype.getProviderByModuleName = function(moduleName) {
        var module = this.moduleNamesToModules.get(moduleName);
        if (module && module.isEnabled()) return module.getProvider();
        else return undefined;
    };
    return BaseFrameworkAdaptor;
}();

});


parcelRegister("35ARm", function(module, exports) {

var $3VFsf = parcelRequire("3VFsf");

var $aqhgV = parcelRequire("aqhgV");
/**
 * This class provides the Connect client framework adaptor implementation for CaaS.
 */ var $23fe6e4bed9ed961$var$CaaSFrameworkAdaptor = /** @class */ function(_super) {
    $3VFsf.__extends(CaaSFrameworkAdaptor, _super);
    function CaaSFrameworkAdaptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CaaSFrameworkAdaptor.prototype.registerModuleWithHost = function(moduleName, simpleXdmDefinition) {
    // Removing the dependency on connect-client to ensure we don't bloat out the size of
    // the code unnecessarily. The following line will be re-instated during the migration
    // to CaaS.
    //defineModule(moduleName, simpleXdmDefinition);
    };
    return CaaSFrameworkAdaptor;
}((0, $aqhgV.BaseFrameworkAdaptor));
var $23fe6e4bed9ed961$export$6fe9107a24d38c8 = new $23fe6e4bed9ed961$var$CaaSFrameworkAdaptor();

});

parcelRegister("ePhLx", function(module, exports) {

$parcel$export(module.exports, "ConnectIframe", () => $acb39c02768266f3$export$8968565585c2471b);

var $3VFsf = parcelRequire("3VFsf");

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $2VbVm = parcelRequire("2VbVm");

var $cTPBv = parcelRequire("cTPBv");

var $13sZL = parcelRequire("13sZL");

var $flFwl = parcelRequire("flFwl");
var $acb39c02768266f3$export$62aa48085237e36f = Object.freeze({
    INIT: Symbol('init'),
    LOADED: Symbol('loaded'),
    FAILED: Symbol('failed'),
    TIMEOUT: Symbol('timeout'),
    LOADING: Symbol('loading'),
    RESOLVING: Symbol('resolving')
});
/**
 * ConnectIframe represents an add-on within a view.
 *
 * Important: Many iframe props, such as URL and options (context) cannot be changed after the iframe has been initialized.
 * This is because these props are passed to the iframe upon initial creation.
 * If you wish to change these properties, you must force the React component to be destroyed and recreated.
 * The easiest way to do this is by using React's "key" prop to create a new instance of the component.
 */ var $acb39c02768266f3$export$8968565585c2471b = /** @class */ function(_super) {
    $3VFsf.__extends(ConnectIframe, _super);
    function ConnectIframe(props) {
        var _this = _super.call(this, props) || this;
        _this.unmountCallbacks = [];
        _this.resize = function(width, height) {
            _this.setState({
                width: width,
                height: height
            });
        };
        _this.sizeToParent = function() {
            _this.setState({
                width: '100%',
                height: '100%'
            });
        };
        _this.registerUnmountCallback = function(callback) {
            _this.unmountCallbacks.push(callback);
        };
        _this.hideInlineDialog = function() {
            if (_this.props.connectIframeProvider.onHideInlineDialog) _this.props.connectIframeProvider.onHideInlineDialog();
        };
        _this.getId = function() {
            if (_this.iframeAttributes) return _this.iframeAttributes.id;
            else return null;
        };
        _this.getIFrameLifecycleEventManager = function() {
            return _this.iframeLifecycleEventManager;
        };
        _this.iframeEstablishedCallback = function() {
            _this.setState({
                loadingState: $acb39c02768266f3$export$62aa48085237e36f.LOADED
            });
        };
        _this.iframeFailedToLoadCallback = function() {
            _this.setState({
                loadingState: $acb39c02768266f3$export$62aa48085237e36f.FAILED
            });
        };
        _this.iframeTimeoutCallback = function() {
            _this.setState({
                loadingState: $acb39c02768266f3$export$62aa48085237e36f.TIMEOUT
            });
        };
        _this._createIFrameLifecycleManager = function() {
            _this.iframeLifecycleEventManager = new (0, $13sZL.default)(_this);
        };
        _this._unregisterIFrameLifecycleManager = function() {
            if (_this.iframeLifecycleEventManager) _this.iframeLifecycleEventManager.unregister(_this);
        };
        _this._createExtension = function() {
            var simpleXdmExtension = _this.props.connectHost.createExtension({
                addon_key: _this.iframeContext.appKey,
                key: _this.iframeContext.moduleKey,
                url: _this.iframeContext.url,
                options: Object.assign({
                    hostFrameOffset: 1
                }, _this.iframeContext.options, {
                    resize: _this.resize.bind(_this),
                    sizeToParent: _this.sizeToParent.bind(_this),
                    registerUnmountCallback: _this.registerUnmountCallback.bind(_this),
                    _contextualOperations: {
                        hideInlineDialog: _this.hideInlineDialog.bind(_this)
                    }
                })
            });
            _this.iframeAttributes = simpleXdmExtension.iframeAttributes;
            (0, $2VbVm.logger).debug('Created iframe for add-on ', _this.iframeContext.appKey, _this.iframeAttributes);
            (0, $cTPBv.analytics).trigger((0, $flFwl.AnalyticsCategories).iframe, (0, $cTPBv.analytics).markAsSafe.apply((0, $cTPBv.analytics), (0, $flFwl.allowedStrings))((0, $flFwl.AnalyticsActions).create), (0, $cTPBv.analytics).dangerouslyCreateSafeString(_this.iframeContext.appKey), {});
        };
        _this._destroyExtension = function() {
            if (_this.iframeAttributes) _this.props.connectHost.destroy(_this.iframeAttributes.id);
        };
        _this._isSubIframe = function() {
            return _this.state.hostFrameOffset && _this.state.hostFrameOffset > 1;
        };
        _this._initialise = function() {
            if (_this.props.children && _this.props.connectIframeProvider.onStoreNestedIframeJSON) {
                var childComponent = _this.props.children;
                var childProps = childComponent.props;
                _this.props.connectIframeProvider.onStoreNestedIframeJSON(childProps);
            }
            if (_this._isSubIframe()) {
                _this.setState({
                    loadingState: $acb39c02768266f3$export$62aa48085237e36f.LOADING
                });
                return;
            }
            _this._createIFrameLifecycleManager();
            if (!_this.props.connectIframeProvider.resolveIframeContext) {
                _this._createExtension();
                _this.setState({
                    loadingState: $acb39c02768266f3$export$62aa48085237e36f.LOADING
                });
                return;
            }
            _this.props.connectIframeProvider.resolveIframeContext(_this.iframeContext, _this.props.connectHost).then(function(iframeContext) {
                var propsMutated = iframeContext.appKey !== _this.props.appKey || iframeContext.moduleKey !== _this.props.moduleKey;
                if (propsMutated) {
                    (0, $2VbVm.logger).warn('Iframe context changed during resolution');
                    return;
                }
                _this.iframeContext = iframeContext;
                _this._createExtension();
                _this.setState({
                    loadingState: $acb39c02768266f3$export$62aa48085237e36f.LOADING
                });
            });
        };
        _this.state = {
            width: props.width,
            height: props.height,
            loadingState: $acb39c02768266f3$export$62aa48085237e36f.INIT,
            hostFrameOffset: props.options.hostFrameOffset || 1
        };
        _this.iframeContext = {
            url: props.url,
            appKey: props.appKey,
            moduleKey: props.moduleKey,
            options: props.options
        };
        return _this;
    }
    ConnectIframe.prototype.componentWillReceiveProps = function(nextProps) {
        if (this.props.appKey !== nextProps.appKey || this.props.moduleKey !== nextProps.moduleKey) {
            this._unregisterIFrameLifecycleManager();
            this._destroyExtension();
            this.setState({
                width: nextProps.width,
                height: nextProps.height,
                hostFrameOffset: nextProps.options.hostFrameOffset || 1,
                loadingState: $acb39c02768266f3$export$62aa48085237e36f.INIT
            });
            this.iframeContext = {
                url: nextProps.url,
                appKey: nextProps.appKey,
                moduleKey: nextProps.moduleKey,
                options: nextProps.options
            };
        }
    };
    ConnectIframe.prototype.componentWillUnmount = function() {
        this.unmountCallbacks.forEach(function(cb) {
            return cb();
        });
        this._unregisterIFrameLifecycleManager();
        this._destroyExtension();
    };
    ConnectIframe.prototype.render = function() {
        switch(this.state.loadingState){
            case $acb39c02768266f3$export$62aa48085237e36f.LOADED:
            case $acb39c02768266f3$export$62aa48085237e36f.LOADING:
            case $acb39c02768266f3$export$62aa48085237e36f.TIMEOUT:
                var iframeStyles = void 0;
                // Ask the product for the styles to use...
                if (this.props.connectIframeProvider.buildIframeStyles) iframeStyles = this.props.connectIframeProvider.buildIframeStyles(this.state.loadingState, $acb39c02768266f3$export$62aa48085237e36f);
                // if iframeStyles is undefined and loadingState is loading/timeout, set the default style
                if (!iframeStyles && (this.state.loadingState === $acb39c02768266f3$export$62aa48085237e36f.LOADING || this.state.loadingState === $acb39c02768266f3$export$62aa48085237e36f.TIMEOUT)) iframeStyles = {
                    opacity: 0.0
                };
                return $5uXOq.createElement(this.props.iframeContainer, {
                    width: this.state.width,
                    height: this.state.height
                }, this.state.loadingState === $acb39c02768266f3$export$62aa48085237e36f.TIMEOUT ? $5uXOq.createElement(this.props.timeoutIndicator, {
                    failedCallback: this.iframeFailedToLoadCallback.bind(this)
                }) : null, this.state.loadingState === $acb39c02768266f3$export$62aa48085237e36f.LOADING ? $5uXOq.createElement(this.props.loadingIndicator, null) : null, this._isSubIframe() ? this.props.children : $5uXOq.createElement("iframe", $3VFsf.__assign({
                    frameBorder: "0",
                    width: this.state.width,
                    height: this.state.height,
                    style: $3VFsf.__assign({
                        display: 'block'
                    }, iframeStyles)
                }, this.iframeAttributes, {
                    "aria-label": this.props.options.title
                }, {
                    referrerPolicy: 'no-referrer'
                }), this.props.children));
            case $acb39c02768266f3$export$62aa48085237e36f.FAILED:
                return $5uXOq.createElement("div", {
                    style: {
                        height: this.state.height
                    }
                }, $5uXOq.createElement(this.props.failedToLoadIndicator, null));
            case $acb39c02768266f3$export$62aa48085237e36f.INIT:
            case $acb39c02768266f3$export$62aa48085237e36f.RESOLVING:
            default:
                return null;
        }
    };
    ConnectIframe.prototype.componentDidMount = function() {
        if (this.state.loadingState === $acb39c02768266f3$export$62aa48085237e36f.INIT) {
            this.setState({
                loadingState: $acb39c02768266f3$export$62aa48085237e36f.RESOLVING
            });
            this._initialise();
        }
    };
    ConnectIframe.prototype.componentDidUpdate = function() {
        if (this.state.loadingState === $acb39c02768266f3$export$62aa48085237e36f.INIT) {
            this.setState({
                loadingState: $acb39c02768266f3$export$62aa48085237e36f.RESOLVING
            });
            this._initialise();
        }
    };
    ConnectIframe.propTypes = {
        connectHost: $8rCP3.object.isRequired,
        appKey: $8rCP3.string.isRequired,
        moduleKey: $8rCP3.string.isRequired,
        iframeContainer: $8rCP3.func,
        loadingIndicator: $8rCP3.func,
        failedToLoadIndicator: $8rCP3.func,
        timeoutIndicator: $8rCP3.func,
        url: $8rCP3.string,
        width: $8rCP3.string,
        height: $8rCP3.string,
        options: $8rCP3.object,
        connectIframeProvider: $8rCP3.object
    };
    ConnectIframe.defaultProps = {
        options: {},
        connectIframeProvider: {},
        iframeContainer: function(_a) {
            var width = _a.width, height = _a.height, children = _a.children;
            return $5uXOq.createElement("div", {
                style: {
                    position: 'relative',
                    width: width === '100%' ? '100%' : 'auto',
                    height: height === '100%' ? '100%' : 'auto'
                }
            }, children);
        },
        failedToLoadIndicator: function() {
            return null;
        },
        loadingIndicator: function() {
            return null;
        },
        timeoutIndicator: function() {
            return null;
        }
    };
    return ConnectIframe;
}($5uXOq.PureComponent);

});
parcelRegister("13sZL", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c4c901c3a6e26b3$export$2e2bcd8739ae039);

var $2VbVm = parcelRequire("2VbVm");

var $cTPBv = parcelRequire("cTPBv");

var $flFwl = parcelRequire("flFwl");
/*
 * Same as in ACJS. See loading_indicator.js.
 */ var $0c4c901c3a6e26b3$var$DEFAULT_APP_LOADING_TIMEOUT = 12000;
var $0c4c901c3a6e26b3$var$connectIframes = [];
var $0c4c901c3a6e26b3$var$registerHostCallbacks = true;
var $0c4c901c3a6e26b3$var$hostIframeEstablishedCallback = function(data) {
    var connectIframe = $0c4c901c3a6e26b3$var$connectIframes.find(function(connectIframe) {
        return data.extension.id === connectIframe.getId();
    });
    if (connectIframe) {
        var manager = connectIframe.getIFrameLifecycleEventManager();
        if (manager) manager.iframeEstablishedCallback(data);
    }
};
var $0c4c901c3a6e26b3$var$hostIframeUnloadCallback = function(data) {
    var connectIframe = $0c4c901c3a6e26b3$var$connectIframes.find(function(connectIframe) {
        return data.extension.id === connectIframe.getId();
    });
    if (connectIframe) {
        var manager = connectIframe.getIFrameLifecycleEventManager();
        if (manager) manager.iframeUnloadCallback(data);
    }
};
var $0c4c901c3a6e26b3$var$IFrameLifecycleEventManager = /** @class */ function() {
    function IFrameLifecycleEventManager(connectIframe) {
        var _this = this;
        this.reset = function() {
            $0c4c901c3a6e26b3$var$connectIframes = [];
            $0c4c901c3a6e26b3$var$registerHostCallbacks = true;
        };
        this.unregister = function(connectIframe) {
            var index = $0c4c901c3a6e26b3$var$connectIframes.indexOf(connectIframe);
            if (index > -1) $0c4c901c3a6e26b3$var$connectIframes.splice(index, 1);
            _this.clearTimeoutDetectionProcessing();
        };
        this.iframeEstablishedCallback = function(data) {
            (0, $2VbVm.logger).debug('Established iframe for add-on ', data.extension.addon_key, data);
            if (_this.connectIframe.props.connectIframeProvider.handleIframeLoadingComplete) _this.connectIframe.props.connectIframeProvider.handleIframeLoadingComplete(data.extension.addon_key);
            var loadTime = new Date().getTime();
            var durationToLoadMs = loadTime - _this.creationTimeMs;
            var payload = {
                hostFrameOffset: (0, $cTPBv.analytics).dangerouslyCreateSafeString((_this.connectIframe.props.options.hostFrameOffset || 1).toString()),
                durationToLoadMs: (0, $cTPBv.analytics).dangerouslyCreateSafeString(durationToLoadMs.toString())
            };
            (0, $cTPBv.analytics).trigger((0, $flFwl.AnalyticsCategories).iframe, (0, $cTPBv.analytics).markAsSafe.apply((0, $cTPBv.analytics), (0, $flFwl.allowedStrings))((0, $flFwl.AnalyticsActions).established), (0, $cTPBv.analytics).dangerouslyCreateSafeString(data.extension.addon_key), payload);
            _this.connectIframe.iframeEstablishedCallback();
            _this.clearTimeoutDetectionProcessing();
        };
        this.iframeUnloadCallback = function(data) {
            (0, $2VbVm.logger).debug('Unloaded iframe for add-on ', data.extension.id, data);
            if (_this.connectIframe.props.connectIframeProvider.handleIframeUnload) _this.connectIframe.props.connectIframeProvider.handleIframeUnload(data.extension.id);
            var unloadTime = new Date().getTime();
            var sessionDurationMs = unloadTime - _this.creationTimeMs;
            var payload = {
                hostFrameOffset: (0, $cTPBv.analytics).dangerouslyCreateSafeString((_this.connectIframe.props.options.hostFrameOffset || 1).toString()),
                sessionDurationMs: (0, $cTPBv.analytics).dangerouslyCreateSafeString(sessionDurationMs.toString())
            };
            (0, $cTPBv.analytics).trigger((0, $flFwl.AnalyticsCategories).iframe, (0, $cTPBv.analytics).markAsSafe.apply((0, $cTPBv.analytics), (0, $flFwl.allowedStrings))((0, $flFwl.AnalyticsActions).close), (0, $cTPBv.analytics).dangerouslyCreateSafeString(data.extension.id), payload);
        };
        this.startTimeoutDetectionProcessing = function() {
            (0, $2VbVm.logger).debug('Starting iframe timed out processing for add-on ', _this.connectIframe.props.appKey);
            var timeoutMilliseconds = _this.getLoadingTimeout();
            _this.timeoutHandle = window.setTimeout(function() {
                (0, $2VbVm.logger).warn('Add-on iframe timed out for add-on ', _this.connectIframe.props.appKey);
                _this.timeoutHandle = 0;
                if (_this.connectIframe.props.connectIframeProvider.handleIframeLoadTimeout) _this.connectIframe.props.connectIframeProvider.handleIframeLoadTimeout(_this.connectIframe.props.appKey, _this.connectIframe.iframeFailedToLoadCallback.bind(_this));
                var payload = {
                    hostFrameOffset: (0, $cTPBv.analytics).dangerouslyCreateSafeString((_this.connectIframe.props.options.hostFrameOffset || 1).toString())
                };
                (0, $cTPBv.analytics).trigger((0, $flFwl.AnalyticsCategories).iframe, (0, $cTPBv.analytics).markAsSafe.apply((0, $cTPBv.analytics), (0, $flFwl.allowedStrings))((0, $flFwl.AnalyticsActions).timeout), (0, $cTPBv.analytics).dangerouslyCreateSafeString(_this.connectIframe.props.appKey), payload);
                _this.connectIframe.iframeTimeoutCallback();
            }, timeoutMilliseconds);
        };
        this.getLoadingTimeout = function() {
            var providedTimeoutMilliseconds = _this.connectIframe.props.connectIframeProvider.getLoadingTimeoutMilliseconds ? _this.connectIframe.props.connectIframeProvider.getLoadingTimeoutMilliseconds(_this.connectIframe.props.appKey) : $0c4c901c3a6e26b3$var$DEFAULT_APP_LOADING_TIMEOUT;
            var timeoutMilliseconds = providedTimeoutMilliseconds && providedTimeoutMilliseconds > 0 ? providedTimeoutMilliseconds : $0c4c901c3a6e26b3$var$DEFAULT_APP_LOADING_TIMEOUT;
            return timeoutMilliseconds;
        };
        this.clearTimeoutDetectionProcessing = function() {
            if (_this.timeoutHandle) {
                (0, $2VbVm.logger).debug('Clearing iframe timed out timer for add-on ', _this.connectIframe.props.appKey);
                window.clearTimeout(_this.timeoutHandle);
                _this.timeoutHandle = 0;
            }
        };
        this.creationTimeMs = new Date().getTime();
        this.connectIframe = connectIframe;
        $0c4c901c3a6e26b3$var$connectIframes.push(connectIframe);
        if ($0c4c901c3a6e26b3$var$registerHostCallbacks) {
            this.connectIframe.props.connectHost.onIframeEstablished($0c4c901c3a6e26b3$var$hostIframeEstablishedCallback);
            this.connectIframe.props.connectHost.onIframeUnload($0c4c901c3a6e26b3$var$hostIframeUnloadCallback);
            $0c4c901c3a6e26b3$var$registerHostCallbacks = false;
        }
        this.startTimeoutDetectionProcessing();
        if (this.connectIframe.props.connectIframeProvider.handleIframeLoadingStarted) this.connectIframe.props.connectIframeProvider.handleIframeLoadingStarted(this.connectIframe.props.appKey);
    }
    return IFrameLifecycleEventManager;
}();
var $0c4c901c3a6e26b3$export$2e2bcd8739ae039 = $0c4c901c3a6e26b3$var$IFrameLifecycleEventManager;

});
parcelRegister("flFwl", function(module, exports) {

$parcel$export(module.exports, "AnalyticsCategories", () => $b2c90658a722aa34$export$99cb2c76c1f7b090);
$parcel$export(module.exports, "AnalyticsActions", () => $b2c90658a722aa34$export$9dbfb0e4698d080f);
$parcel$export(module.exports, "allowedStrings", () => $b2c90658a722aa34$export$cb67e4122f7d424a);
var $b2c90658a722aa34$export$99cb2c76c1f7b090;
(function(AnalyticsCategories) {
    AnalyticsCategories.dialog = 'dialog';
    AnalyticsCategories.iframe = 'iframe';
    AnalyticsCategories.inlineDialog = 'inlineDialog';
})($b2c90658a722aa34$export$99cb2c76c1f7b090 || ($b2c90658a722aa34$export$99cb2c76c1f7b090 = {}));
var $b2c90658a722aa34$export$9dbfb0e4698d080f;
(function(AnalyticsActions) {
    AnalyticsActions.create = 'create';
    AnalyticsActions.close = 'close';
    AnalyticsActions.error = 'error';
    AnalyticsActions.timeout = 'timeout';
    AnalyticsActions.established = 'established';
})($b2c90658a722aa34$export$9dbfb0e4698d080f || ($b2c90658a722aa34$export$9dbfb0e4698d080f = {}));
var $b2c90658a722aa34$export$cb67e4122f7d424a = [
    $b2c90658a722aa34$export$9dbfb0e4698d080f.create,
    $b2c90658a722aa34$export$9dbfb0e4698d080f.close,
    $b2c90658a722aa34$export$9dbfb0e4698d080f.error,
    $b2c90658a722aa34$export$9dbfb0e4698d080f.timeout,
    $b2c90658a722aa34$export$9dbfb0e4698d080f.established
];

});



parcelRegister("lmpfU", function(module, exports) {

var $3VFsf = parcelRequire("3VFsf");

var $3J6n1 = parcelRequire("3J6n1");

var $7gBsT = parcelRequire("7gBsT");
var $f8cf3e44f205350b$export$748372235e8d793;
(function(FlagModuleDefinitions) {
    FlagModuleDefinitions.FLAG_MODULE_NAME = 'flag';
    var Props = /** @class */ function() {
        function Props(adaptor, flagProvider) {
            this.adaptor = adaptor;
            this.flagProvider = flagProvider;
        }
        return Props;
    }();
    FlagModuleDefinitions.Props = Props;
    var State = /** @class */ function() {
        function State(flagProvider) {
            this.enabled = true;
            this.registered = false;
            this.flagProvider = flagProvider;
            this.simpleXdmDefinitionBuilder = new (0, $7gBsT.FlagSimpleXdmDefinitionBuilder)(flagProvider);
        }
        return State;
    }();
    FlagModuleDefinitions.State = State;
})($f8cf3e44f205350b$export$748372235e8d793 || ($f8cf3e44f205350b$export$748372235e8d793 = {}));
/**
 * This module provides flag related functionality.
 */ var $f8cf3e44f205350b$export$7031eb52127e17da = /** @class */ function(_super) {
    $3VFsf.__extends(FlagModule, _super);
    function FlagModule(props) {
        return _super.call(this, props) || this;
    }
    FlagModule.prototype.componentWillMount = function() {
        if (!this.props.flagProvider) throw new Error('this.props.flagProvider is not defined');
        this.setState(new $f8cf3e44f205350b$export$748372235e8d793.State(this.props.flagProvider));
    };
    FlagModule.prototype.getModuleRegistrationName = function() {
        return $f8cf3e44f205350b$export$748372235e8d793.FLAG_MODULE_NAME;
    };
    FlagModule.prototype.getSimpleXdmDefinitionBuilder = function() {
        return this.state.simpleXdmDefinitionBuilder;
    };
    FlagModule.prototype.getProvider = function() {
        return this.props.flagProvider;
    };
    FlagModule.prototype.render = function() {
        return null;
    };
    return FlagModule;
}((0, $3J6n1.BaseModule));

});
parcelRegister("3J6n1", function(module, exports) {

$parcel$export(module.exports, "BaseModule", () => $2b6a8413364306fb$export$adea4f5921a64958);

var $3VFsf = parcelRequire("3VFsf");

var $5uXOq = parcelRequire("5uXOq");

var $2VbVm = parcelRequire("2VbVm");
var $2b6a8413364306fb$export$ff885fcfc37de939;
(function(ModuleDefinitions) {
    ModuleDefinitions.MIN_REGISTRATION_NAME_LENGTH = 1;
    ModuleDefinitions.MAX_REGISTRATION_NAME_LENGTH = 50;
})($2b6a8413364306fb$export$ff885fcfc37de939 || ($2b6a8413364306fb$export$ff885fcfc37de939 = {}));
/**
 * This class provides common module behaviour and characteristics. The term 'Module' refers to
 * a set of related functionality and provides the interface between a product that requires the
 * module functionality and the framework that implements it.
 */ var $2b6a8413364306fb$export$adea4f5921a64958 = /** @class */ function(_super) {
    $3VFsf.__extends(BaseModule, _super);
    function BaseModule(props) {
        return _super.call(this, props) || this;
    }
    BaseModule.prototype.componentDidMount = function() {
        var props = this.props;
        var registrationName = this.getModuleRegistrationName();
        (0, $2VbVm.logger).debug('Mounting module', registrationName, '...');
        this.validateRegistrationName(registrationName);
        props.adaptor.registerModule(this, props);
        var moduleState = this.state;
        moduleState.enabled = true;
        moduleState.registered = true;
        this.setState(moduleState);
    };
    BaseModule.prototype.setEnabled = function(enabled) {
        var moduleState = this.state;
        moduleState.enabled = enabled;
        this.setState(moduleState);
    };
    BaseModule.prototype.isEnabled = function() {
        return this.state.enabled;
    };
    BaseModule.prototype.componentWillUnmount = function() {
    // Do nothing - we don't unregister modules.
    };
    BaseModule.prototype.shouldComponentUpdate = function() {
        // This module hierarchy never renders anything.
        return false;
    };
    BaseModule.prototype.validateRegistrationName = function(registrationName) {
        if (!registrationName || registrationName.length < $2b6a8413364306fb$export$ff885fcfc37de939.MIN_REGISTRATION_NAME_LENGTH) throw new Error('The registration name is too short (< ' + $2b6a8413364306fb$export$ff885fcfc37de939.MIN_REGISTRATION_NAME_LENGTH + ' characters).');
        if (registrationName.length > $2b6a8413364306fb$export$ff885fcfc37de939.MAX_REGISTRATION_NAME_LENGTH) throw new Error('The registration name is too long (> ' + $2b6a8413364306fb$export$ff885fcfc37de939.MAX_REGISTRATION_NAME_LENGTH + ' characters).');
        if (!registrationName.match(/^[a-z]+$/i)) throw new Error('The registration name must only contain alphabetic characters.');
    };
    BaseModule.prototype.render = function() {
        return null;
    };
    return BaseModule;
}($5uXOq.Component);

});

parcelRegister("7gBsT", function(module, exports) {

$parcel$export(module.exports, "FlagSimpleXdmDefinitionBuilder", () => $54a716cd9b8326fc$export$94f22dab2f68a598);
var $54a716cd9b8326fc$export$94f22dab2f68a598 = /** @class */ function() {
    function FlagSimpleXdmDefinitionBuilder(flagProvider) {
        if (!flagProvider) throw new Error('flagProvider is not defined');
        this.flagProvider = flagProvider;
    }
    FlagSimpleXdmDefinitionBuilder.prototype.buildSimpleXdmDefinition = function() {
        var flagProvider = this.flagProvider;
        /*
         * This class is a proxy to the flag object created by the flag provider. It is
         * equivalent to the Flag class defined in atlassian-connect-js/src/modules/flag.js
         * except that it does not pull in any AUI flag implementation.
         */ var FlagProxy = /** @class */ function() {
            function FlagProxy(options, callback) {
                options.id = callback._id;
                var flagId = callback._id;
                var actions = [];
                if (typeof options.actions === 'object') actions = Object.getOwnPropertyNames(options.actions).map(function(key) {
                    return {
                        actionKey: key,
                        actionText: options.actions[key],
                        executeAction: function() {
                            console.log('This needs to be implemented by broadcasting a "flag-action-invoked" event.');
                        }
                    };
                });
                var flagOptions = {
                    id: flagId,
                    title: options.title,
                    body: options.body,
                    actions: actions,
                    onClose: function() {
                        console.log('This needs to be implemented by broadcasting a "flag.close" event.');
                    },
                    close: options.close,
                    type: options.type.toLowerCase()
                };
                this.flag = flagProvider.create(flagOptions);
            }
            FlagProxy.prototype.close = function() {
                this.flag.close();
            };
            return FlagProxy;
        }();
        return {
            create: {
                constructor: FlagProxy,
                close: FlagProxy.prototype.close
            }
        };
    };
    return FlagSimpleXdmDefinitionBuilder;
}();

});


parcelRegister("bVKdY", function(module, exports) {

var $cTPBv = parcelRequire("cTPBv");

var $flFwl = parcelRequire("flFwl");

var $2VbVm = parcelRequire("2VbVm");
/**
 * This is the default way that products should use to implement InlineDialogProvider operations.
 */ var $8af8dfc91ef76a37$export$42f4559178b41306 = /** @class */ function() {
    function DefaultInlineDialogProvider() {}
    DefaultInlineDialogProvider.prototype.hide = function(appContext) {
        var appHasHideOperation = appContext.extension.options._contextualOperations && appContext.extension.options._contextualOperations.hideInlineDialog && typeof appContext.extension.options._contextualOperations.hideInlineDialog === 'function';
        if (appHasHideOperation) {
            appContext.extension.options._contextualOperations.hideInlineDialog();
            (0, $2VbVm.logger).debug('Hiding inline dialog...');
            (0, $cTPBv.analytics).trigger((0, $flFwl.AnalyticsCategories).inlineDialog, (0, $flFwl.AnalyticsActions).close, appContext.extension.addon_key, {});
        } else {
            (0, $2VbVm.logger).warn('Attempted to hide the inline dialog for a malformed app: ', appContext);
            (0, $cTPBv.analytics).trigger((0, $flFwl.AnalyticsCategories).inlineDialog, (0, $flFwl.AnalyticsActions).error, appContext.extension.addon_key, {
                message: 'No hideInlineDialog function'
            });
        }
    };
    return DefaultInlineDialogProvider;
}();

});

parcelRegister("dfrrn", function(module, exports) {

var $3VFsf = parcelRequire("3VFsf");

var $3J6n1 = parcelRequire("3J6n1");

var $aD4SR = parcelRequire("aD4SR");
var $9a51f62d59929173$export$b2c1533e87918fe9;
(function(DialogModuleDefinitions) {
    DialogModuleDefinitions.DIALOG_MODULE_NAME = 'dialog';
    var Props = /** @class */ function() {
        function Props(adaptor, dialogProvider) {
            this.adaptor = adaptor;
            this.dialogProvider = dialogProvider;
        }
        return Props;
    }();
    DialogModuleDefinitions.Props = Props;
    var State = /** @class */ function() {
        function State(dialogProvider) {
            this.enabled = true;
            this.registered = false;
            this.dialogProvider = dialogProvider;
            this.simpleXdmDefinitionBuilder = new (0, $aD4SR.DialogSimpleXdmDefinitionBuilder)(dialogProvider);
        }
        return State;
    }();
    DialogModuleDefinitions.State = State;
})($9a51f62d59929173$export$b2c1533e87918fe9 || ($9a51f62d59929173$export$b2c1533e87918fe9 = {}));
/**
 * This module provides dialog related functionality.
 */ var $9a51f62d59929173$export$d9193a0e0fca7cd8 = /** @class */ function(_super) {
    $3VFsf.__extends(DialogModule, _super);
    function DialogModule(props) {
        return _super.call(this, props) || this;
    }
    DialogModule.prototype.componentWillMount = function() {
        if (!this.props.dialogProvider) throw new Error('this.props.dialogProvider is not defined');
        this.setState(new $9a51f62d59929173$export$b2c1533e87918fe9.State(this.props.dialogProvider));
    };
    DialogModule.prototype.getModuleRegistrationName = function() {
        return $9a51f62d59929173$export$b2c1533e87918fe9.DIALOG_MODULE_NAME;
    };
    DialogModule.prototype.getSimpleXdmDefinitionBuilder = function() {
        return this.state.simpleXdmDefinitionBuilder;
    };
    DialogModule.prototype.getProvider = function() {
        return this.props.dialogProvider;
    };
    DialogModule.prototype.render = function() {
        return null;
    };
    return DialogModule;
}((0, $3J6n1.BaseModule));

});
parcelRegister("aD4SR", function(module, exports) {

$parcel$export(module.exports, "DialogSimpleXdmDefinitionBuilder", () => $7bd155b978d99112$export$b85c05da5be2a57c);
var $7bd155b978d99112$export$b85c05da5be2a57c = /** @class */ function() {
    function DialogSimpleXdmDefinitionBuilder(dialogProvider) {
        if (!dialogProvider) throw new Error('dialogProvider is not defined');
        this.dialogProvider = dialogProvider;
    }
    DialogSimpleXdmDefinitionBuilder.prototype.buildSimpleXdmDefinition = function() {
        return {};
    };
    return DialogSimpleXdmDefinitionBuilder;
}();

});


parcelRegister("3ZL3k", function(module, exports) {

var $3VFsf = parcelRequire("3VFsf");

var $3J6n1 = parcelRequire("3J6n1");

var $2436g = parcelRequire("2436g");
var $2e8b914ecd3fdc4a$export$4279eadb1f181402;
(function(DropdownModuleDefinitions) {
    DropdownModuleDefinitions.DROPDOWN_MODULE_NAME = 'dropdown';
    var Props = /** @class */ function() {
        function Props(adaptor, dropdownProvider) {
            this.adaptor = adaptor;
            this.dropdownProvider = dropdownProvider;
        }
        return Props;
    }();
    DropdownModuleDefinitions.Props = Props;
    var State = /** @class */ function() {
        function State(dropdownProvider) {
            this.enabled = true;
            this.registered = false;
            this.dropdownProvider = dropdownProvider;
            this.simpleXdmDefinitionBuilder = new (0, $2436g.DropdownSimpleXdmDefinitionBuilder)(dropdownProvider);
        }
        return State;
    }();
    DropdownModuleDefinitions.State = State;
})($2e8b914ecd3fdc4a$export$4279eadb1f181402 || ($2e8b914ecd3fdc4a$export$4279eadb1f181402 = {}));
/**
 * This module provides dropdown related functionality.
 */ var $2e8b914ecd3fdc4a$export$f4d87b4303498ba0 = /** @class */ function(_super) {
    $3VFsf.__extends(DropdownModule, _super);
    function DropdownModule(props) {
        return _super.call(this, props) || this;
    }
    DropdownModule.prototype.componentWillMount = function() {
        if (!this.props.dropdownProvider) throw new Error('this.props.dropdownProvider is not defined');
        this.setState(new $2e8b914ecd3fdc4a$export$4279eadb1f181402.State(this.props.dropdownProvider));
    };
    DropdownModule.prototype.getModuleRegistrationName = function() {
        return $2e8b914ecd3fdc4a$export$4279eadb1f181402.DROPDOWN_MODULE_NAME;
    };
    DropdownModule.prototype.getSimpleXdmDefinitionBuilder = function() {
        return this.state.simpleXdmDefinitionBuilder;
    };
    DropdownModule.prototype.getProvider = function() {
        return this.props.dropdownProvider;
    };
    DropdownModule.prototype.render = function() {
        return null;
    };
    return DropdownModule;
}((0, $3J6n1.BaseModule));

});
parcelRegister("2436g", function(module, exports) {

$parcel$export(module.exports, "DropdownSimpleXdmDefinitionBuilder", () => $180e5c149fab4232$export$338fba6bed3be020);
var $180e5c149fab4232$export$338fba6bed3be020 = /** @class */ function() {
    function DropdownSimpleXdmDefinitionBuilder(dropdownProvider) {
        if (!dropdownProvider) throw new Error('dropdownProvider is not defined');
        this.dropdownProvider = dropdownProvider;
    }
    DropdownSimpleXdmDefinitionBuilder.prototype.buildSimpleXdmDefinition = function() {
        return {};
    };
    return DropdownSimpleXdmDefinitionBuilder;
}();

});


parcelRegister("6WeGo", function(module, exports) {

var $3VFsf = parcelRequire("3VFsf");

var $3J6n1 = parcelRequire("3J6n1");

var $karcc = parcelRequire("karcc");
var $50d38c8a328facb7$export$ae7b722dbdc6e5c7;
(function(InlineDialogModuleDefinitions) {
    InlineDialogModuleDefinitions.INLINE_DIALOG_MODULE_NAME = 'inlineDialog';
    var Props = /** @class */ function() {
        function Props(adaptor, inlineDialogProvider) {
            this.adaptor = adaptor;
            this.inlineDialogProvider = inlineDialogProvider;
        }
        return Props;
    }();
    InlineDialogModuleDefinitions.Props = Props;
    var State = /** @class */ function() {
        function State(inlineDialogProvider) {
            this.enabled = true;
            this.registered = false;
            this.inlineDialogProvider = inlineDialogProvider;
            this.simpleXdmDefinitionBuilder = new (0, $karcc.InlineDialogSimpleXdmDefinitionBuilder)(inlineDialogProvider);
        }
        return State;
    }();
    InlineDialogModuleDefinitions.State = State;
})($50d38c8a328facb7$export$ae7b722dbdc6e5c7 || ($50d38c8a328facb7$export$ae7b722dbdc6e5c7 = {}));
/**
 * This module provides inlineDialog related functionality.
 */ var $50d38c8a328facb7$export$b1f44b14f5988e61 = /** @class */ function(_super) {
    $3VFsf.__extends(InlineDialogModule, _super);
    function InlineDialogModule(props) {
        return _super.call(this, props) || this;
    }
    InlineDialogModule.prototype.componentWillMount = function() {
        if (!this.props.inlineDialogProvider) throw new Error('this.props.inlineDialogProvider is not defined');
        this.setState(new $50d38c8a328facb7$export$ae7b722dbdc6e5c7.State(this.props.inlineDialogProvider));
    };
    InlineDialogModule.prototype.getModuleRegistrationName = function() {
        return $50d38c8a328facb7$export$ae7b722dbdc6e5c7.INLINE_DIALOG_MODULE_NAME;
    };
    InlineDialogModule.prototype.getSimpleXdmDefinitionBuilder = function() {
        return this.state.simpleXdmDefinitionBuilder;
    };
    InlineDialogModule.prototype.getProvider = function() {
        return this.props.inlineDialogProvider;
    };
    InlineDialogModule.prototype.render = function() {
        return null;
    };
    return InlineDialogModule;
}((0, $3J6n1.BaseModule));

});
parcelRegister("karcc", function(module, exports) {

$parcel$export(module.exports, "InlineDialogSimpleXdmDefinitionBuilder", () => $eae9d656a3b35220$export$f57ca3ba8378bc0b);
var $eae9d656a3b35220$export$f57ca3ba8378bc0b = /** @class */ function() {
    function InlineDialogSimpleXdmDefinitionBuilder(inlineDialogProvider) {
        if (!inlineDialogProvider) throw new Error('inlineDialogProvider is not defined');
        this.inlineDialogProvider = inlineDialogProvider;
    }
    InlineDialogSimpleXdmDefinitionBuilder.prototype.buildSimpleXdmDefinition = function() {
        return {};
    };
    return InlineDialogSimpleXdmDefinitionBuilder;
}();

});


parcelRegister("bw22u", function(module, exports) {

var $3VFsf = parcelRequire("3VFsf");

var $3J6n1 = parcelRequire("3J6n1");

var $NDXuH = parcelRequire("NDXuH");
var $862443c80c24a838$export$8322ec4fed7b0ec;
(function(MessageModuleDefinitions) {
    MessageModuleDefinitions.MESSAGE_MODULE_NAME = 'messages';
    var Props = /** @class */ function() {
        function Props(adaptor, messageProvider) {
            this.adaptor = adaptor;
            this.messageProvider = messageProvider;
        }
        return Props;
    }();
    MessageModuleDefinitions.Props = Props;
    var State = /** @class */ function() {
        function State(messageProvider) {
            this.enabled = true;
            this.registered = false;
            this.messageProvider = messageProvider;
            this.simpleXdmDefinitionBuilder = new (0, $NDXuH.MessageSimpleXdmDefinitionBuilder)(messageProvider);
        }
        return State;
    }();
    MessageModuleDefinitions.State = State;
})($862443c80c24a838$export$8322ec4fed7b0ec || ($862443c80c24a838$export$8322ec4fed7b0ec = {}));
/**
 * This module provides message related functionality.
 */ var $862443c80c24a838$export$22578b4f731c13ad = /** @class */ function(_super) {
    $3VFsf.__extends(MessageModule, _super);
    function MessageModule(props) {
        return _super.call(this, props) || this;
    }
    MessageModule.prototype.componentWillMount = function() {
        if (!this.props.messageProvider) throw new Error('this.props.messageProvider is not defined');
        this.setState(new $862443c80c24a838$export$8322ec4fed7b0ec.State(this.props.messageProvider));
    };
    MessageModule.prototype.getModuleRegistrationName = function() {
        return $862443c80c24a838$export$8322ec4fed7b0ec.MESSAGE_MODULE_NAME;
    };
    MessageModule.prototype.getSimpleXdmDefinitionBuilder = function() {
        return this.state.simpleXdmDefinitionBuilder;
    };
    MessageModule.prototype.getProvider = function() {
        return this.props.messageProvider;
    };
    MessageModule.prototype.render = function() {
        return null;
    };
    return MessageModule;
}((0, $3J6n1.BaseModule));

});
parcelRegister("NDXuH", function(module, exports) {

$parcel$export(module.exports, "MessageSimpleXdmDefinitionBuilder", () => $095392a8ea682dc9$export$a2377c7acc103422);
var $095392a8ea682dc9$export$a2377c7acc103422 = /** @class */ function() {
    function MessageSimpleXdmDefinitionBuilder(messageProvider) {
        if (!messageProvider) throw new Error('messageProvider is not defined');
        this.messageProvider = messageProvider;
    }
    MessageSimpleXdmDefinitionBuilder.prototype.buildSimpleXdmDefinition = function() {
        return {};
    };
    return MessageSimpleXdmDefinitionBuilder;
}();

});


parcelRegister("d4ZAG", function(module, exports) {

var $4o6FR = parcelRequire("4o6FR");
/**
 * This class validates an instance of DialogProvider. This is intended to be used by consumers of this library in
 * their tests to validate their implementations. Knowing products have incorporated this into their test suite will
 * allow breaking changes to be introduced in the library.
 */ var $985b6cb423adfe86$export$728f00fa4551317c = /** @class */ function() {
    function DialogProviderValidator() {}
    DialogProviderValidator.validate = function(dialogProvider) {
        (0, $4o6FR.default).checkFunctionExists('dialogProvider', dialogProvider, 'create');
        (0, $4o6FR.default).checkFunctionExists('dialogProvider', dialogProvider, 'close');
        (0, $4o6FR.default).checkFunctionExists('dialogProvider', dialogProvider, 'setButtonDisabled');
        (0, $4o6FR.default).checkFunctionExists('dialogProvider', dialogProvider, 'isButtonDisabled');
        (0, $4o6FR.default).checkFunctionExists('dialogProvider', dialogProvider, 'toggleButton');
        (0, $4o6FR.default).checkFunctionExists('dialogProvider', dialogProvider, 'setButtonHidden');
        (0, $4o6FR.default).checkFunctionExists('dialogProvider', dialogProvider, 'isButtonHidden');
        (0, $4o6FR.default).checkFunctionExists('dialogProvider', dialogProvider, 'isActiveDialog');
        var actionClicked = false;
        var myAction = {
            identifier: 'my-action',
            text: 'Some Action',
            onClick: function() {
                actionClicked = true;
            }
        };
        var dialogCreationOptions = {
            key: 'my-dialog',
            size: 'medium',
            width: '100%',
            height: '50px',
            chrome: false,
            header: 'My header',
            actions: [
                myAction
            ],
            closeOnEscape: true,
            hint: 'this is a test'
        };
        var bogus_addon_key = 'bogus_app';
        var addon_key = 'foo-app';
        var dialogExtension = {
            addon_key: addon_key,
            key: 'foo-key',
            options: {}
        };
        var dialog = dialogProvider.create(dialogCreationOptions, dialogExtension);
        // Allow contenet resolver promises to complete
        setTimeout(function() {
            // TODO: Fix under ACJS-735
            // ValidationUtil.checkExists('dialog', dialog);
            // ValidationUtil.checkFunctionExists('dialog', dialog, 'on');
            // Check the dialog is active...
            var isActiveAfterCreation = dialogProvider.isActiveDialog(addon_key);
            if (!isActiveAfterCreation) throw new Error('The dialog should be active');
            // Check the active status returns false for another add-on...
            var isAnotherAppsDialogActive = dialogProvider.isActiveDialog(bogus_addon_key);
            if (isAnotherAppsDialogActive) throw new Error('The dialog should not be active');
            // Check the enabled state of a button...
            if (dialogProvider.isButtonDisabled('my-action')) throw new Error('Button should be enabled by default');
            // Disable a button...
            dialogProvider.setButtonDisabled('my-action', true);
            if (!dialogProvider.isButtonDisabled('my-action')) throw new Error('Button should have been disabled.');
            // Re-enabled a button...
            dialogProvider.toggleButton('my-action');
            if (dialogProvider.isButtonDisabled('my-action')) throw new Error('Button should have been re-enabled.');
            // Check the visibility of a button...
            if (dialogProvider.isButtonHidden('my-action')) throw new Error('Button should be visible by default');
            // Hide a button...
            dialogProvider.setButtonHidden('my-action', true);
            if (!dialogProvider.isButtonHidden('my-action')) throw new Error('Button should have been hidden.');
            dialogProvider.close();
        }, 0);
    };
    return DialogProviderValidator;
}();

});
parcelRegister("4o6FR", function(module, exports) {

$parcel$export(module.exports, "default", () => $331e94a829fcea00$export$2e2bcd8739ae039);
var $331e94a829fcea00$export$fa29912b5fdf77b5 = /** @class */ function() {
    function ValidationUtil() {}
    ValidationUtil.checkExists = function(objectName, object) {
        if (!object) throw new Error(objectName + " does not exist.");
    };
    ValidationUtil.checkPropertyExists = function(objectName, object, propertyName) {
        var objectProperty = object[propertyName];
        if (!objectProperty) throw new Error("Expected " + objectName + " to have a property: " + propertyName + ".");
        if (ValidationUtil.isFunction(objectProperty)) throw new Error(objectName + " has a property " + propertyName + ", but it is a function.");
    };
    ValidationUtil.checkFunctionExists = function(objectName, object, functionName) {
        var objectProperty = object[functionName];
        if (!objectProperty) throw new Error("Expected " + objectName + " to have a function: " + functionName + ".");
        if (!ValidationUtil.isFunction(objectProperty)) {
            var objectPropertyTypeInfo = typeof objectProperty + ' (value: ' + objectProperty + ')';
            throw new Error(objectName + " has a property " + functionName + ", but it is a " + objectPropertyTypeInfo + " rather than a function.");
        }
    };
    ValidationUtil.isFunction = function(object) {
        return typeof object === 'function';
    };
    return ValidationUtil;
}();
var $331e94a829fcea00$export$2e2bcd8739ae039 = $331e94a829fcea00$export$fa29912b5fdf77b5;

});


parcelRegister("910u1", function(module, exports) {

var $dnv7K = parcelRequire("dnv7K");

var $4o6FR = parcelRequire("4o6FR");
/**
 * This class validates an instance of FlagProvider. This is intended to be used by consumers of this library in
 * their tests to validate their implementations. Knowing products have incorporated this into their test suite will
 * allow breaking changes to be introduced in the library.
 */ var $690494ff80369a2e$export$a28584b2365c8dd4 = /** @class */ function() {
    function FlagProviderValidator() {}
    FlagProviderValidator.validate = function(flagProvider) {
        (0, $4o6FR.default).checkFunctionExists('flagProvider', flagProvider, 'create');
        (0, $4o6FR.default).checkFunctionExists('flagProvider', flagProvider, 'isFlagOpen');
        FlagProviderValidator.validateFlagCreationAndDeletions(flagProvider, 'manual');
        FlagProviderValidator.validateFlagCreationAndDeletions(flagProvider, 'auto');
        FlagProviderValidator.validateFlagCreationAndDeletions(flagProvider, 'never');
    };
    FlagProviderValidator.validateFlagCreationAndDeletions = function(flagProvider, closeFlagOption) {
        var flagActions = [];
        FlagProviderValidator.validateFlagCreationAndDeletion(flagProvider, closeFlagOption, flagActions, false);
        var flagAction = new (0, $dnv7K.FlagAction)();
        flagAction.actionKey = 'some-action';
        flagAction.actionText = 'Some Action';
        flagAction.executeAction = function() {
            console.log('Action clicked');
        };
        flagActions.push(flagAction);
        FlagProviderValidator.validateFlagCreationAndDeletion(flagProvider, closeFlagOption, flagActions, false);
        var flagActionMissingExecuteAction = new (0, $dnv7K.FlagAction)();
        flagActionMissingExecuteAction.actionKey = 'some-action';
        flagActionMissingExecuteAction.actionText = 'Some Action';
        flagActions[0] = flagActionMissingExecuteAction;
        FlagProviderValidator.validateFlagCreationAndDeletion(flagProvider, closeFlagOption, flagActions, true);
    };
    FlagProviderValidator.validateFlagCreationAndDeletion = function(flagProvider, closeFlagOption, flagActions, expectValidationError) {
        var flagIdsToFlags = new Map();
        var flagId = 'flag-' + new Date().getMilliseconds();
        var flagOptions = {
            id: flagId,
            title: 'My Flag',
            body: 'My flag content',
            type: 'success',
            close: closeFlagOption,
            onClose: function(flagId) {
                flagIdsToFlags.delete(flagId);
            },
            actions: flagActions
        };
        try {
            var flag = flagProvider.create(flagOptions);
            if (expectValidationError) throw new Error('Expected a validation error, but did not get one.');
            flagIdsToFlags.set(flag.id, flag);
            (0, $4o6FR.default).checkExists('flag', flag);
            (0, $4o6FR.default).checkFunctionExists('flag', flag, 'close');
            if (closeFlagOption !== 'auto') {
                var flagOpen = flagProvider.isFlagOpen(flag.id);
                if (!flagOpen) throw new Error("Expected flag to exist.");
            }
            flag.close();
            if (flagIdsToFlags.size) throw new Error('It looks like the provider did not synchronously call back the onClose method.');
        } catch (exception) {
            if (expectValidationError) ;
            else throw new Error('Did not expect a validation error, but got one.');
        }
    };
    return FlagProviderValidator;
}();

});
parcelRegister("dnv7K", function(module, exports) {

$parcel$export(module.exports, "FlagAction", () => $9bd590e4c0697a64$export$137131383bc80874);
var $9bd590e4c0697a64$export$137131383bc80874 = /** @class */ function() {
    function FlagAction() {}
    return FlagAction;
}();
/**
 * This interface describes the options controlling the creation of flags.
 */ var $9bd590e4c0697a64$export$b7026fd91c62192e = /** @class */ function() {
    function FlagCreationOptions() {}
    return FlagCreationOptions;
}();

});


parcelRegister("bIfPx", function(module, exports) {

var $4o6FR = parcelRequire("4o6FR");

var $lz1uV = parcelRequire("lz1uV");
/**
 * This class validates an instance of InlineDialogProvider. This is intended to be used by consumers of this library in
 * their tests to validate their implementations. Knowing products have incorporated this into their test suite will
 * allow breaking changes to be introduced in the library.
 */ var $88701556c40d3f00$export$c73136b548ed0f6f = /** @class */ function() {
    function InlineDialogProviderValidator() {}
    InlineDialogProviderValidator.validate = function(inlineDialogProvider) {
        (0, $4o6FR.default).checkFunctionExists('inlineDialogProvider', inlineDialogProvider, 'hide');
        var appContext = (0, $lz1uV.TestAppContext).buildNewInstance();
        inlineDialogProvider.hide(appContext);
    };
    return InlineDialogProviderValidator;
}();

});
parcelRegister("lz1uV", function(module, exports) {

$parcel$export(module.exports, "TestAppContext", () => $fb2e074ce4ec6fe1$export$c2ea901ef0c0e837);
var $fb2e074ce4ec6fe1$export$2d6b340a940d682f = /** @class */ function() {
    function TestContextualOperations() {
        this.inlineDialogOpen = true;
    }
    TestContextualOperations.prototype.resize = function(width, height) {
        throw new Error('Not implemented yet');
    };
    TestContextualOperations.prototype.sizeToParent = function() {
        throw new Error('Not implemented yet');
    };
    /**
     * This method hides the inline dialog that the add-on identified by this context is
     * being displayed in.
     */ TestContextualOperations.prototype.hideInlineDialog = function() {
        this.inlineDialogOpen = false;
    };
    TestContextualOperations.prototype.isInlineDialogOpen = function() {
        return this.inlineDialogOpen;
    };
    return TestContextualOperations;
}();
var $fb2e074ce4ec6fe1$export$f4e04f09a1f31b14 = /** @class */ function() {
    function TestAppInstance(appKey, id, key, options) {
        this.addon_key = appKey;
        this.id = id;
        this.key = key;
        this.options = options;
    }
    return TestAppInstance;
}();
var $fb2e074ce4ec6fe1$export$13e597eb521ea346 = /** @class */ function() {
    function TestAppOptions(autoresize, widthinpx, hostFrameOffset, _contextualOperations) {
        this.autoresize = autoresize;
        this.widthinpx = widthinpx;
        this.hostFrameOffset = hostFrameOffset;
        this._contextualOperations = _contextualOperations;
    }
    return TestAppOptions;
}();
var $fb2e074ce4ec6fe1$export$c2ea901ef0c0e837 = /** @class */ function() {
    function TestAppContext(extension) {
        this.extension = extension;
    }
    TestAppContext.buildNewInstance = function() {
        var contextualOperations = new $fb2e074ce4ec6fe1$export$2d6b340a940d682f();
        var autoresize = true;
        var widthinpx = true;
        var hostFrameOffset = 1;
        var appOptions = new $fb2e074ce4ec6fe1$export$13e597eb521ea346(autoresize, widthinpx, hostFrameOffset, contextualOperations);
        var randomId = new Date().getMilliseconds();
        var appKey = 'foo';
        var key = 'bar';
        var id = appKey + '__' + key + '__' + randomId;
        var appInstance = new $fb2e074ce4ec6fe1$export$f4e04f09a1f31b14(appKey, id, key, appOptions);
        var appContext = new TestAppContext(appInstance);
        return appContext;
    };
    return TestAppContext;
}();

});


parcelRegister("ioF2x", function(module, exports) {

var $4o6FR = parcelRequire("4o6FR");
/**
 * This class validates an instance of MessageProvider. This is intended to be used by consumers of this library in
 * their tests to validate their implementations. Knowing products have incorporated this into their test suite will
 * allow breaking changes to be introduced in the library.
 */ var $d64a4d8dac4d0a6d$export$4aff556677cdd09a = /** @class */ function() {
    function MessageProviderValidator() {}
    MessageProviderValidator.validate = function(messageProvider) {
        (0, $4o6FR.default).checkFunctionExists('messageProvider', messageProvider, 'clear');
        (0, $4o6FR.default).checkFunctionExists('messageProvider', messageProvider, 'onClose');
        var creationRoutineNames = [
            'generic',
            'hint',
            'info',
            'success',
            'warning',
            'error'
        ];
        creationRoutineNames.forEach(function(creationRoutineName) {
            (0, $4o6FR.default).checkFunctionExists('messageProvider', messageProvider, creationRoutineName);
            var messageId = 'message-' + new Date().getMilliseconds();
            var title = 'My Message';
            var body = 'My message content';
            var messageOptions = {
                id: messageId,
                closeable: true,
                fadeout: true,
                delay: 2000,
                duration: 4000
            };
            if (creationRoutineName === 'generic') messageProvider.generic(title, body, messageOptions);
            else if (creationRoutineName === 'hint') messageProvider.hint(title, body, messageOptions);
            else if (creationRoutineName === 'info') messageProvider.info(title, body, messageOptions);
            else if (creationRoutineName === 'success') messageProvider.success(title, body, messageOptions);
            else if (creationRoutineName === 'warning') messageProvider.warning(title, body, messageOptions);
            else if (creationRoutineName === 'error') messageProvider.error(title, body, messageOptions);
            (0, $4o6FR.default).checkExists('messageId', messageId);
            var dummyOnCloseCalled = false;
            var onCloseCalled = false;
            messageProvider.onClose(messageId, function() {
                onCloseCalled = true;
            });
            messageProvider.onClose('dummy-message-id', function() {
                dummyOnCloseCalled = true;
            });
            messageProvider.clear(messageId);
            if (!onCloseCalled) throw new Error('Expected onClose callback to be called after calling clear.');
            if (dummyOnCloseCalled) throw new Error('Did not expect the dummy onClose callback to be called.');
        });
    };
    return MessageProviderValidator;
}();

});

parcelRegister("ch5cI", function(module, exports) {

var $avNCo = parcelRequire("avNCo");
/**
 * This class provides a mock implementation of ConnectHost.
 */ var $8efb1c03a247156f$export$d34d7bcfe7ba9cee = /** @class */ function() {
    function MockConnectHost() {
        this.onIframeEstablished = jest.fn();
        this.offIframeEstablished = jest.fn();
        this.onIframeUnload = jest.fn();
        this.offIframeUnload = jest.fn();
        this.createExtension = jest.fn(function(params) {
            var val = new (0, $avNCo.MockSimpleXdmExtension);
            val.iframeAttributes.src = params.url;
            return val;
        });
        this.destroy = jest.fn();
        this.getContentResolver = jest.fn();
        this.hasJwt = jest.fn();
        this.isJwtExpired = jest.fn();
    }
    return MockConnectHost;
}();

});
parcelRegister("avNCo", function(module, exports) {

$parcel$export(module.exports, "MockSimpleXdmExtension", () => $7a7349ce706a34cc$export$1cddb33ac1c7fcc0);

var $fAjtd = parcelRequire("fAjtd");
var $7a7349ce706a34cc$export$1cddb33ac1c7fcc0 = /** @class */ function() {
    function MockSimpleXdmExtension() {
        this.iframeAttributes = new (0, $fAjtd.MockConnectIframeInterface)();
        this.extension = {};
    }
    return MockSimpleXdmExtension;
}();

});
parcelRegister("fAjtd", function(module, exports) {

$parcel$export(module.exports, "MockConnectIframeInterface", () => $b589522b1e1ed052$export$72c538805177fc9d);
var $b589522b1e1ed052$export$72c538805177fc9d = /** @class */ function() {
    function MockConnectIframeInterface() {
        this.id = 'mock-iframe-id';
        this.src = 'mock-iframe-src';
        this.name = 'mock-iframe-name';
    }
    return MockConnectIframeInterface;
}();

});




parcelRegister("hhZhQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7ac8ad334a8d85f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useDefaultConnectIframeProvider", () => $d7ac8ad334a8d85f$export$ac083e2d52357959);
/* eslint-disable no-param-reassign */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $dJl1T = parcelRequire("dJl1T");
// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
const $d7ac8ad334a8d85f$var$log = (message, event)=>(0, $dJl1T.default).safeInfoWithoutCustomerData('Ecosystem.DefaultConnectIFrameProvider', message, event);
class $d7ac8ad334a8d85f$export$2e2bcd8739ae039 {
    constructor({ handleHideInlineDialog: handleHideInlineDialog, handleOnLoadingComplete: handleOnLoadingComplete, handleOnTimeout: handleOnTimeout, isAutoresizeBugfixEnabled: isAutoresizeBugfixEnabled } = {}){
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
        this.convertConnectOptions = (data)=>window._AP._convertConnectOptions(data).options;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onStoreNestedIframeJSON = (connectAppProps)=>{
            $d7ac8ad334a8d85f$var$log('onStoreNestedIframeJSON', connectAppProps);
        };
        this.getLoadingTimeoutMilliseconds = (appKey)=>{
            $d7ac8ad334a8d85f$var$log('getLoadingTimeoutMilliseconds', {
                appKey: appKey
            });
            // In the ACJS we use an aggressive timeout value so we can test more quickly.
            return 30000;
        };
        this.handleIframeLoadingStarted = (appKey)=>{
            $d7ac8ad334a8d85f$var$log('handleIframeLoadingStarted', {
                appKey: appKey
            });
        };
        this.handleIframeLoadingComplete = (appKey)=>{
            this.handleOnLoadingComplete();
            $d7ac8ad334a8d85f$var$log('handleIframeLoadingComplete', {
                appKey: appKey
            });
        };
        this.handleIframeUnload = (appKey)=>{
            $d7ac8ad334a8d85f$var$log('handleIframeUnload', {
                appKey: appKey
            });
        };
        this.handleIframeLoadTimeout = (appKey)=>{
            this.handleOnTimeout();
            $d7ac8ad334a8d85f$var$log('handleIframeLoadTimeout', {
                appKey: appKey
            });
        };
        this.isJwtExpired = (url, connectHost)=>{
            if (connectHost.hasJwt && connectHost.isJwtExpired) return url && connectHost.hasJwt(url) && connectHost.isJwtExpired(url);
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            $d7ac8ad334a8d85f$var$log('connectHost missing JWT utilities');
            return false;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.sanitiseContext = (ctx)=>typeof ctx === 'string' ? JSON.parse(ctx) : ctx;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.buildIframeStyles = (loadingState, LoadingState)=>{
            if (loadingState === LoadingState.TIMEOUT) return {
                opacity: 0.0,
                height: '0px'
            };
            if (loadingState === LoadingState.LOADED) {
                // This is a hack to try to prevent the autoresize behaviour in the atlassian-connect/all.js for connect addons from
                // self-sizing to zero height (we see this flake very occasionally in pollinator)
                // We should see logs of this occurring outside pollinator when switched on in prod if it is a bug affecting customers.
                if (this.isAutoresizeBugfixEnabled && this.iframeContext && this.connectHost) {
                    const iframes = Object.keys(this.connectHost?.getExtensions()).filter((extensionKey)=>this.iframeContext && extensionKey.startsWith(this.iframeContext.options?.uniqueKey))// prettier-ignore
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    .map((extensionKey)=>window.document.getElementById(extensionKey)).filter((node)=>node != null);
                    iframes.forEach((iframe)=>{
                        if (iframe?.style?.height === '0px') {
                            (0, $dJl1T.default).safeWarnWithoutCustomerData('ecosystem.iframe.provider', `Connect addon iframe with 0 height in loaded state. Set to 100%. appKey: ${this.iframeContext?.appKey ?? 'null'}, modulekey: ${this.iframeContext?.moduleKey ?? 'null'}`);
                            iframe.style.height = '100%';
                        }
                    });
                }
                return {
                    opacity: 1.0,
                    maxWidth: '100%'
                };
            }
            return null;
        };
        this.resolveIframeContext = (iframeContext, connectHost)=>{
            this.iframeContext = iframeContext;
            this.connectHost = connectHost;
            return new Promise((resolve)=>{
                if (iframeContext.url && !this.isJwtExpired(iframeContext.url, connectHost)) {
                    resolve(iframeContext);
                    return;
                }
                if (!connectHost.getContentResolver || !connectHost.getContentResolver()) {
                    // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
                    $d7ac8ad334a8d85f$var$log('No content resolver supplied');
                    resolve(iframeContext);
                    return;
                }
                let options;
                try {
                    options = {
                        ...iframeContext.options,
                        productContext: this.sanitiseContext(iframeContext.options.productContext || iframeContext.options.productCtx || {}),
                        structuredContext: this.sanitiseContext(iframeContext.options.structuredContext || iframeContext.options.structuredCtx || {})
                    };
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
                    $d7ac8ad334a8d85f$var$log('Unable to parse supplied productCtx');
                    resolve(iframeContext);
                    return;
                }
                connectHost.getContentResolver()({
                    addon_key: iframeContext.appKey,
                    key: iframeContext.moduleKey,
                    options: options,
                    classifier: 'json'
                }).then((promiseData)=>{
                    /* eslint-disable no-prototype-builtins */ if (typeof promiseData !== 'object' || !promiseData.hasOwnProperty('url')) {
                        // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
                        $d7ac8ad334a8d85f$var$log('Invalid response');
                        resolve(iframeContext);
                    } else resolve({
                        url: promiseData.url,
                        appKey: promiseData.addon_key || iframeContext.appKey,
                        moduleKey: promiseData.key || iframeContext.moduleKey,
                        options: {
                            ...iframeContext.options,
                            ...promiseData.options
                        }
                    });
                });
            });
        };
        this.handleHideInlineDialog = handleHideInlineDialog || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.handleOnLoadingComplete = handleOnLoadingComplete || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.handleOnTimeout = handleOnTimeout || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.isAutoresizeBugfixEnabled = isAutoresizeBugfixEnabled || false;
    }
    onHideInlineDialog() {
        this.handleHideInlineDialog();
        // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
        $d7ac8ad334a8d85f$var$log('DefaultConnectAppProvider.onHideInlineDialog');
    }
}
const $d7ac8ad334a8d85f$export$44a359abb235afe0 = (props)=>{
    const providerRef = (0, $5uXOq.useRef)();
    if (providerRef.current == null) providerRef.current = new $d7ac8ad334a8d85f$export$2e2bcd8739ae039(props);
    return providerRef.current;
};
const $d7ac8ad334a8d85f$export$3135535e219232c6 = (props)=>(0, $5uXOq.useState)(()=>new $d7ac8ad334a8d85f$export$2e2bcd8739ae039(props))[0];
const $d7ac8ad334a8d85f$export$ac083e2d52357959 = (props)=>$d7ac8ad334a8d85f$export$3135535e219232c6(props);

});

parcelRegister("jfasb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d96b3d0555101d8$export$2e2bcd8739ae039);

var $uPntJ = parcelRequire("uPntJ");

var $8Vh1q = parcelRequire("8Vh1q");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9d96b3d0555101d8$export$2e2bcd8739ae039 = async (baseUrl, addonKey, moduleKey, queryParams = {})=>(0, $uPntJ.default)(baseUrl, addonKey, moduleKey, queryParams).then((0, $8Vh1q.transformResponse));

});
parcelRegister("uPntJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6777008b9e9f43ee$export$2e2bcd8739ae039);

var $ebyGx = parcelRequire("ebyGx");

var $7f4tk = parcelRequire("7f4tk");
const $6777008b9e9f43ee$export$7138c24907de3954 = (baseUrl, addonKey, moduleKey, queryParams)=>`${baseUrl}/plugins/servlet/ac/${addonKey}/${moduleKey}?classifier=json&${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(queryParams)}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6777008b9e9f43ee$export$2e2bcd8739ae039 = (baseUrl, addonKey, moduleKey, queryParams)=>(0, $7f4tk.default)($6777008b9e9f43ee$export$7138c24907de3954(baseUrl, addonKey, moduleKey, queryParams), {
        method: 'POST'
    });

});



parcelRegister("l8CHx", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e63735b2926b810$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $lL5b5 = parcelRequire("lL5b5");

var $i2Rm5 = parcelRequire("i2Rm5");

var $jJZqs = parcelRequire("jJZqs");

var $id7K0 = parcelRequire("id7K0");

var $5rqex = parcelRequire("5rqex");

var $g5X3G = parcelRequire("g5X3G");

var $9dbF6 = parcelRequire("9dbF6");

var $4dRjY = parcelRequire("4dRjY");

var $dZw8H = parcelRequire("dZw8H");

var $9OXo1 = parcelRequire("9OXo1");

var $61cnf = parcelRequire("61cnf");
const $7e63735b2926b810$var$ErrorComponent = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
        id: "jira-connect",
        error: error
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7e63735b2926b810$export$2e2bcd8739ae039 = ({ ConnectIframeLegacyApp: ConnectIframeLegacyApp, prefetchResult: prefetchResult, baseUrl: baseUrl, addonKey: addonKey, moduleKey: moduleKey, queryParams: queryParams, onLoadingComplete: onLoadingComplete, onTimeout: onTimeout, onError: onError })=>{
    const { error: prefetchError, loading: loading, data: data } = prefetchResult;
    const { atlassianAccountId: atlassianAccountId } = (0, $9OXo1.useTenantContext)();
    const status = data?.status || prefetchError instanceof (0, $jJZqs.default) && prefetchError.statusCode || prefetchError instanceof Error && prefetchError.name === 'FetchError' && 'statusCode' in prefetchError && prefetchError.statusCode;
    if (status === 401 && !atlassianAccountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lL5b5.default), null);
    if (prefetchError || status && status >= 400) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
        id: "jira-connect",
        error: prefetchError
    });
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
    const title = data && data.title || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: title
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConnectIframeLegacyApp, {
        addonKey: addonKey,
        moduleKey: moduleKey,
        baseUrl: (0, $g5X3G.toBaseUrl)(baseUrl),
        prefetchResult: data,
        frameHeight: "100%",
        frameWidth: "100%",
        TimeoutIndicator: $7e63735b2926b810$var$ErrorComponent,
        LoadingIndicator: (0, $kb4zh.default),
        queryParams: queryParams,
        onLoadingComplete: onLoadingComplete,
        onTimeout: onTimeout,
        onError: onError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        appName: "jira-connect",
        isExpectedToHaveSsr: true,
        metric: (0, $61cnf.jiraConnectPageLoad),
        extra: {
            moduleType: data?.moduleType
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "addon"
    }));
};

});
parcelRegister("lL5b5", function(module, exports) {

$parcel$export(module.exports, "default", () => $07c2532655d93687$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $j0xEB = parcelRequire("j0xEB");

var $j2Jlg = parcelRequire("j2Jlg");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07c2532655d93687$export$2e2bcd8739ae039 = ()=>{
    const { href: href = null } = (0, $j0xEB.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j2Jlg.default), {
            url: `/login.jsp?os_destination=${encodedRedirectUrl}`
        });
    }
    return null;
};

});
parcelRegister("j2Jlg", function(module, exports) {

$parcel$export(module.exports, "default", () => $773e6f988af77e5c$export$2e2bcd8739ae039);

var $gKZoD = parcelRequire("gKZoD");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$773e6f988af77e5c$export$2e2bcd8739ae039 = ({ url: url })=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.assign(url);
    return null;
};

});


parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $kUJAW = parcelRequire("kUJAW");

var $9UjYX = parcelRequire("9UjYX");

var $4ED9C = parcelRequire("4ED9C");

var $kw6Pi = parcelRequire("kw6Pi");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $kw6Pi.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUJAW.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UjYX.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $4ED9C.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("9UjYX", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $513dd79a43e30317$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $513dd79a43e30317$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $513dd79a43e30317$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $l27qC = parcelRequire("l27qC");

var $4ED9C = parcelRequire("4ED9C");

var $6V56P = parcelRequire("6V56P");
function $513dd79a43e30317$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $513dd79a43e30317$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $l27qC.default));
    const interactionId = (0, $4ED9C.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $6V56P.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $513dd79a43e30317$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $513dd79a43e30317$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $4ED9C.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $6V56P.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $513dd79a43e30317$export$f02972da195a43bb(marks, timingsConfig);
        (0, $6V56P.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $l27qC = parcelRequire("l27qC");

var $4raQk = parcelRequire("4raQk");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $4raQk.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $l27qC.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $l27qC = parcelRequire("l27qC");

var $kw6Pi = parcelRequire("kw6Pi");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $kw6Pi.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $kw6Pi.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $l27qC.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $4ED9C = parcelRequire("4ED9C");

var $6V56P = parcelRequire("6V56P");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $4ED9C.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $6V56P.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $4ED9C = parcelRequire("4ED9C");

var $6V56P = parcelRequire("6V56P");

var $kw6Pi = parcelRequire("kw6Pi");
var $b5KMq = parcelRequire("b5KMq");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $4ED9C.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $kw6Pi.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $b5KMq.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $6V56P.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $4ED9C = parcelRequire("4ED9C");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $4ED9C.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $dJl1T = parcelRequire("dJl1T");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $dJl1T.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("61cnf", function(module, exports) {

$parcel$export(module.exports, "jiraConnectPageLoad", () => $59c0183868515378$export$59bfa922cc6bbd48);

var $a1G10 = parcelRequire("a1G10");
const $59c0183868515378$export$59bfa922cc6bbd48 = (0, $a1G10.metrics).pageLoad({
    key: 'jira-connect',
    ssr: {
        doneAsFmp: true
    }
});

});





//# sourceMappingURL=async-connect.e7afd6a4.js.map
